module.exports = __webpack_public_path__ + "img/logo-minciencias.8dd0169b.png";